(function () {
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initTilt() {
    var tiltEls = document.querySelectorAll('.tilt');
    if (!tiltEls.length) return;

    tiltEls.forEach(function (el) {
      var bounds;

      el.addEventListener('mouseenter', function () {
        bounds = el.getBoundingClientRect();
      });

      el.addEventListener('mousemove', function (e) {
        if (!bounds) bounds = el.getBoundingClientRect();
        var x = (e.clientX - bounds.left) / bounds.width - 0.5;
        var y = (e.clientY - bounds.top) / bounds.height - 0.5;
        var rotateX = (y * -12).toFixed(2);
        var rotateY = (x * 12).toFixed(2);
        el.style.transform =
          'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale3d(1.03, 1.03, 1.03)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initTilt();
    });
  } else {
    initReveal();
    initTilt();
  }
})();
